export { default } from './RemoveWardrobeItemLink'
